import styled from "styled-components";
import CloseIcon from "../icon/closeIcon";
import { useEffect, useState } from "react";
import { categoryList, roomDataList } from "../../types/types";
import { Image } from "../common/image";
import CustomButton from "../common/customButton";
import { text } from "stream/consumers";
import ItemDropdown from "./itemDropdwon";
import CarryTypeSelectionComponent from "./carryTypeSelectionComponent";
import { carryType } from "./../../types/types";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 60vw;
  height: 80vw;
  background-color: white;
  position: fixed;
  border-radius: 1vw;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 52vw;
  height: 72vw;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 6vw;
`;

const Contents = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 56vw;
`;

const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 6vw;
`;

const Title = styled.div`
  width: 43vw;
  font-size: 3vw;
  font-weight: 600;
  display: flex;
  align-items: center;
`;

const CustomTitleBox = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  width: 43vw;
`;

const CustomTitle = styled.div`
  font-size: 3vw;
  font-weight: 600;
  display: inline-block;
  align-items: center;
  white-space: nowrap; /* 줄바꿈 방지 */
`;

const CustomNameBox = styled.div<{
  $isFocused?: boolean;
}>`
  height: 5vw;
  outline: ${(props) =>
    props.$isFocused ? "0.3vw solid #ff7f3b" : "0.3vw solid #626262"};
  border-radius: 0.4vw;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 1vw;
  width: 28vw;
`;

const CustomNameInput = styled.input<{
  $isFocused?: boolean;
}>`
  width: 26vw;
  height: 100%;
  border: none;
  outline: none;
  font-family: "Pretendard";
  font-size: 2.4vw;
`;

const CloseBox = styled.div`
  width: 5vw;
  height: 5vw;
  border-radius: 0.6vw;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f2f2f2;
  &&:hover {
    cursor: pointer;
  }
`;

const ItemSelectionBox = styled.div`
  display: inline-block;
  position: relative;
`;

const ItemSelection = styled.div<{
  index: number;
  $selectedRoom?: number;
}>`
  width: 25.3vw;
  height: 10vw;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2.6vw;
  font-weight: 600;
  border-radius: 0.6vw;
  background-color: ${(props) =>
    props.$selectedRoom === props.index ? "#ff7f3b" : "#f2f2f2"};
  color: ${(props) =>
    props.$selectedRoom === props.index ? "white" : "black"};
`;

const ImageBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 5vw;
  height: 5vw;
  background-color: #ff7f3b;
  border-radius: 100%;
`;

const NameBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 6vw;
  font-size: 2 8vw;
`;

const MessageBox = styled.div`
  width: 100%;
  height: 3vw;
  display: flex;
  justify-content: start;
  align-items: center;
  font-size: 2.6vw;
  color: #ff7f3b;
`;

const CalculationArea = styled.div`
  width: 100%;
  height: 32vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: end;
  border-radius: 0.4vw;
  font-size: 3vw;
`;

const MethodSelectionArea = styled.div`
  width: 100%;
  height: 15vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: end;
  border-radius: 0.4vw;
  font-size: 3vw;
`;

const InputArea = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 10vw;
`;

const Line = styled.div`
  width: 100%;
  outline: 0.16vw solid black;
`;

const OperatorBox = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  font-size: 4vw;
  font-weight: 400;
  margin-right: 2vw;
  width: 10vw;
  height: 4vw;
`;

const SubtitleBox = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  font-size: 2vw;
  font-weight: 400;
  margin-right: 1vw;
`;

const QuantityInputBox = styled.div<{ $isSelected?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30vw;
  height: 6vw;
  outline: ${(props) =>
    props.$isSelected ? "0.3vw solid #ff7f3b" : "0.3vw solid #626262"};
  padding-left: 1vw;
  padding-right: 1vw;
  border-radius: 0.4vw;
`;

const QuantityInput = styled.input.attrs({
  type: "number",
  step: "1", // 정수만 입력 허용
  min: "0", // 최소값 설정
  max: "100", // 최대값 설정
  placeholder: "0",
  inputMode: "decimal",
})`
  display: flex;
  justify-content: end;
  align-items: center;
  text-align: end;
  width: 100%;
  height: 100%;
  outline: none;
  border: none;
  font-size: 2.4vw;
`;
export default function AddItemModal(props: any) {
  const { addNewItem, onClose } = props;
  const roomList = roomDataList;
  const itemList = categoryList;
  const [step, setStep] = useState(1);
  const [selectedCategory, setSelectedCategory] = useState(0);
  const [selectedItemId, setSelectedItemId] = useState(0);
  const [selectedItem, setSelectedItem] = useState<any>();
  const [disableNext, setDisableNext] = useState<boolean>(true);
  const [openDropdown, setOpenDrowdown] = useState<boolean>(false);
  const [customNameOnFocused, setCustomNameOnFocused] = useState<boolean>(true);
  const [quantityOnFocused, setQuantityOnFocused] = useState<boolean>(false);
  const [unitOnFocused, setUnitOnFocused] = useState<boolean>(false);
  const [isCustom, setIsCustom] = useState<boolean>(false);
  const [customName, setCustomName] = useState<any>("");
  const [customUnit, setCustomUnit] = useState<any>("");
  const [quantity, setQuantitiy] = useState<any>("");
  const [totalCbm, setTotalCbm] = useState<any>(0);
  const [carryType, setCarryType] = useState<number>(0);

  const onClickNext = () => {
    setStep(step + 1);
  };

  const onClickPrev = () => {
    setStep(step - 1);
  };

  const onClickOk = () => {
    if (!isCustom) {
      addNewItem(
        selectedCategory,
        selectedItem,
        selectedItem.itemName,
        quantity,
        totalCbm,
        carryType
      );
    } else {
      addNewItem(
        selectedCategory,
        selectedItem,
        customName === "" ? "사용자정의" : customName,
        quantity,
        totalCbm,
        carryType
      );
    }
    onClose();
  };

  const selectCategory = (id: number) => {
    setSelectedCategory(id);
    setOpenDrowdown(true);
  };

  const closeDropdown = () => {
    setOpenDrowdown(false);
  };

  useEffect(() => {
    if (selectedCategory === 0 || selectedItemId === 0) {
      return;
    }
    setSelectedItem(
      itemList[selectedCategory - 1].itemList[selectedItemId - 1]
    );
    setDisableNext(false);
  }, [selectedCategory, selectedItemId]);

  useEffect(() => {
    if (selectedItem) {
      if (selectedItem.isCustom) {
        setIsCustom(true);
      } else {
        setIsCustom(false);
      }
      setQuantitiy(0);
      setCustomUnit(0);
      setTotalCbm(0);
    }
  }, [selectedItem]);

  useEffect(() => {
    // 합계 cbm 계산
    if (isCustom) {
      // 사용자 정의인 경우
      if (customUnit && quantity) {
        let totalCbm = customUnit * quantity;
        setTotalCbm(totalCbm.toFixed(2));
      }
    } else {
      // 일반적인 경우
      if (quantity) {
        let totalCbm = selectedItem.cbm * quantity;
        setTotalCbm(totalCbm.toFixed(2));
      }
    }
  }, [customUnit, quantity]);

  const onChangeCustomName = (e: any) => {
    setCustomName(e.target.value);
  };

  const onChangeUnit = (e: any) => {
    setCustomUnit(e.target.value);
  };

  const onChangeQuantity = (e: any) => {
    setQuantitiy(e.target.value);
  };

  return (
    <Wrapper>
      {step === 1 && (
        <Container>
          <Header>
            <Title>추가할 물품을 선택하세요.</Title>
            <CloseBox>
              <CloseIcon onClick={onClose} height={"3vw"} fill={"#AEAEAE"} />
            </CloseBox>
          </Header>
          <Contents>
            {categoryList.map((item: any) => {
              return (
                <ItemSelectionBox key={item.categoryType}>
                  <ItemSelection
                    index={item.categoryType}
                    onClick={() => selectCategory(item.categoryType)}
                    $selectedRoom={selectedCategory}
                  >
                    <NameBox>{item.categoryName}</NameBox>
                  </ItemSelection>
                  {selectedCategory === item.categoryType && openDropdown && (
                    <ItemDropdown
                      index={selectedCategory}
                      onClose={closeDropdown}
                      selectedItem={selectedItemId}
                      setSelectedItem={setSelectedItemId}
                    ></ItemDropdown>
                  )}
                </ItemSelectionBox>
              );
            })}
          </Contents>

          <Footer>
            <CustomButton
              onClick={onClose}
              text={"취소"}
              size="2.4vw"
              $bgColor="none"
              color="black"
              $border="0.2vw solid black"
              height="100%"
              width="25.3vw"
            ></CustomButton>
            <CustomButton
              onClick={onClickNext}
              text={"다음"}
              size="2.4vw"
              height="100%"
              width="25.3vw"
              disabled={disableNext}
            ></CustomButton>
          </Footer>
        </Container>
      )}
      {step === 2 && (
        <Container>
          <Header>
            {isCustom ? (
              <>
                <CustomTitleBox>
                  <CustomTitle>
                    [{categoryList[selectedCategory - 1].categoryName}]
                  </CustomTitle>
                  <CustomNameBox $isFocused={customNameOnFocused}>
                    <CustomNameInput
                      autoFocus
                      onFocus={() => setCustomNameOnFocused(true)}
                      onBlur={() => setCustomNameOnFocused(false)}
                      onChange={onChangeCustomName}
                      value={customName}
                      $isFocused={customNameOnFocused}
                      placeholder="물품명 입력"
                    ></CustomNameInput>
                  </CustomNameBox>
                </CustomTitleBox>
              </>
            ) : (
              <>
                <Title>
                  [{categoryList[selectedCategory - 1].categoryName}]{" "}
                  {selectedItem.itemName}
                </Title>
              </>
            )}
            <CloseBox>
              <CloseIcon onClick={onClose} height={"3vw"} fill={"#AEAEAE"} />
            </CloseBox>
          </Header>
          {isCustom ? (
            // 사용자 정의인 경우
            <Contents>
              <MessageBox>
                {customNameOnFocused ? "- 물품명을 입력하세요." : ""}
                {unitOnFocused ? "- 물품의 단위(cbm)를 입력하세요." : ""}
                {quantityOnFocused ? "- 물품의 수량을 입력하세요." : ""}
              </MessageBox>
              <CalculationArea>
                <InputArea>
                  <OperatorBox></OperatorBox>
                  <SubtitleBox>단위(cbm)</SubtitleBox>
                  <QuantityInputBox $isSelected={unitOnFocused}>
                    <QuantityInput
                      onFocus={() => setUnitOnFocused(true)}
                      onBlur={() => setUnitOnFocused(false)}
                      onChange={onChangeUnit}
                      value={customUnit}
                    ></QuantityInput>
                  </QuantityInputBox>
                </InputArea>
                <InputArea>
                  <OperatorBox>×</OperatorBox>
                  <SubtitleBox>수량(개)</SubtitleBox>
                  <QuantityInputBox $isSelected={quantityOnFocused}>
                    <QuantityInput
                      onFocus={() => setQuantityOnFocused(true)}
                      onBlur={() => setQuantityOnFocused(false)}
                      onChange={onChangeQuantity}
                      value={quantity}
                    ></QuantityInput>
                  </QuantityInputBox>
                </InputArea>
                <Line></Line>
                <InputArea>
                  <OperatorBox>=</OperatorBox>
                  <SubtitleBox>합계(cbm)</SubtitleBox>
                  <QuantityInputBox>
                    <QuantityInput readOnly value={totalCbm}></QuantityInput>
                  </QuantityInputBox>
                </InputArea>
              </CalculationArea>
              <MethodSelectionArea>
                <CarryTypeSelectionComponent
                  selected={carryType}
                  setSelected={setCarryType}
                ></CarryTypeSelectionComponent>
              </MethodSelectionArea>
            </Contents>
          ) : (
            // 일반적인 경우
            <Contents>
              <MessageBox>물품의 수량을 입력하세요.</MessageBox>
              <CalculationArea>
                <InputArea>
                  <OperatorBox></OperatorBox>
                  <SubtitleBox>단위(cbm)</SubtitleBox>

                  <QuantityInputBox $isSelected={false}>
                    <QuantityInput
                      readOnly
                      value={selectedItem.cbm}
                    ></QuantityInput>
                  </QuantityInputBox>
                </InputArea>
                <InputArea>
                  <OperatorBox>×</OperatorBox>
                  <SubtitleBox>수량(개)</SubtitleBox>
                  <QuantityInputBox $isSelected={quantityOnFocused}>
                    <QuantityInput
                      autoFocus
                      onFocus={() => setQuantityOnFocused(true)}
                      onBlur={() => setQuantityOnFocused(false)}
                      onChange={onChangeQuantity}
                      value={quantity}
                    ></QuantityInput>
                  </QuantityInputBox>
                </InputArea>
                <Line></Line>
                <InputArea>
                  <OperatorBox>=</OperatorBox>
                  <SubtitleBox>합계(cbm)</SubtitleBox>
                  <QuantityInputBox>
                    <QuantityInput readOnly value={totalCbm}></QuantityInput>
                  </QuantityInputBox>
                </InputArea>
              </CalculationArea>
              <MethodSelectionArea>
                <CarryTypeSelectionComponent
                  selected={carryType}
                  setSelected={setCarryType}
                ></CarryTypeSelectionComponent>
              </MethodSelectionArea>
            </Contents>
          )}

          <Footer>
            <CustomButton
              onClick={onClickPrev}
              text={"뒤로"}
              size="2.4vw"
              $bgColor="none"
              color="black"
              $border="0.2vw solid black"
              height="100%"
              width="25.3vw"
            ></CustomButton>
            <CustomButton
              onClick={onClickOk}
              text={"확인"}
              size="2.4vw"
              height="100%"
              width="25.3vw"
            ></CustomButton>
          </Footer>
        </Container>
      )}
    </Wrapper>
  );
}
